import StaffManagerContainer from "../../container/admin/staff-manager";

const StaffManager = () => {
    return <StaffManagerContainer />;
};

export default StaffManager;
